// src/utils/translation-helpers.ts

import type { CategoryDefinition } from '../types'

/**
 * Get translated label for category
 */
export function getCategoryLabel(category: CategoryDefinition, language: string = 'en'): string {
  if (
    category.translations &&
    category.translations[language as keyof typeof category.translations]
  ) {
    return category.translations[language as keyof typeof category.translations].label
  }
  return category.label
}

/**
 * Get translated short description for category
 */
export function getCategoryShortDescription(
  category: CategoryDefinition,
  language: string = 'en'
): string {
  if (
    category.translations &&
    category.translations[language as keyof typeof category.translations]
  ) {
    return category.translations[language as keyof typeof category.translations].shortDescription
  }
  return category.shortDescription || category.description
}

/**
 * Get translated long description for category
 */
export function getCategoryLongDescription(
  category: CategoryDefinition,
  language: string = 'en'
): string {
  if (
    category.translations &&
    category.translations[language as keyof typeof category.translations]
  ) {
    return category.translations[language as keyof typeof category.translations].longDescription
  }
  return category.longDescription || category.description
}
